<template>
  <div class="container-fluid">
    <div class="login-form mx-auto  p-4 m-4 border border-dark rounded">
      <div class=" m-4">
        <div
          style="height: 200px;"
          class=" mx-auto d-block "
          v-bind:class="[isDarkTheme ? 'logo-dark' : 'logo-light']"
        />
      </div>

      <!-- form input -->
      <div v-if="!isLogged" v-on:keyup.enter="clickLogin()">
        <form class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            autocomplete="username"
            v-model="username"
            required="required"
          />

          <input
            type="password"
            autocomplete="current-password"
            class="form-control mt-3"
            placeholder="Password"
            v-model="password"
            required="required"
          />

          <button
            type="submit"
            @click.prevent="clickLogin()"
            class="btn btn-primary btn-block mt-3"
            v-bind:disabled="isLoginDisabled"
          >
            Log in
          </button>
        </form>
      </div>
      <div v-else>
        <h3 class=" p-2 text-center">Ciao, {{ getName || "n/A" }}</h3>
        <div class="form-group">
          <button
            type="submit"
            class="btn btn-primary btn-block"
            @click="goToLibrary"
          >
            Entra
          </button>
          <!-- <button type="submit" @click="logout()" class="btn btn-primary btn-block" > 
            Logout
          </button> -->
        </div>
      </div>

      <!-- <p class="text-center">
        <a href="/logout">Logout</a>
      </p> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import appService from "@/service.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "home",
  data: () => {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    ...mapActions(["login"]),
    clickLogin() {
      var username = this.username;
      var password = this.password;
      this.$store
        .dispatch("login", { username, password })
        .then(() => {
          this.goToLibrary();
        })
        .catch(err => {
          let errorLogin = `<p>Impossibile effettuare il login.<br>${
            err.status
          } - ${err.statusText}</p>`;
          this.$notify({
            group: "notif",
            type: "error",
            duration: 2000,
            title: "<h5>Errore</h5>",
            text: errorLogin
          });
        });
    },
    goToLibrary() {
      this.$router.push("/library");
    }
  },
  computed: {
    ...mapGetters(["isLogged", "getName"]),
    isLoginDisabled() {
      if (this.username == "" || this.password == "") {
        return true;
      }
      return false;
    },
    isDarkTheme() {
      console.log("isdarktheme: " + this.$store.getters.isDarkTheme);

      return this.$store.getters.isDarkTheme;
    }
  },
  watch: {},
  mounted() {
    //controlla se token è ancora valido
    this.$store.dispatch("checkTokenExpired");
  }
};
</script>

<style>
.login-form {
  max-width: 330px;
}

.logo-dark {
  background: url("/logo/aldo-dark.png") no-repeat;
  width: 200px;
  height: 200px;
  display: block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.logo-light {
  background: url("/logo/aldo.png") no-repeat;
  width: 200px;
  height: 200px;
  display: block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
